module.exports = {"140932100":"新关镇","140932102":"老营镇","140932103":"万家寨镇","140932104":"水泉镇","140932105":"老牛湾镇","140932106":"尚峪镇","140932200":"窑头乡","140932201":"楼沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140932.json
// module id = 446
// module chunks = 0